import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=684781cb&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684781cb"]])

export default __exports__